import z from "zod";
import { CustomerDisplayMediaType } from "./enums/CustomerDisplayMediaType";
import { CustomerDisplayCartLayoutType } from "./enums/CustomerDisplayCartLayoutType";
import { CustomerDisplayImageResizeModeType } from "./enums/CustomerDisplayImageResizeModeType";

export const CustomerDisplayMediaImageScheme = z.object({
  type: z.literal(CustomerDisplayMediaType.IMAGE),
  url: z.string(),
  durationSeconds: z.number().optional(),
  enabled: z.boolean().optional(),
});

export const CustomerDisplayMediaVideoScheme = z.object({
  type: z.literal(CustomerDisplayMediaType.VIDEO),
  url: z.string(),
  loop: z.boolean().optional(),
  enabled: z.boolean().optional(),
});

export const CustomerDisplayMediaItemScheme = z.discriminatedUnion("type", [
  CustomerDisplayMediaImageScheme,
  CustomerDisplayMediaVideoScheme,
]);

export const CustomerDisplayIdlePlaylistScheme = z.object({
  items: z.array(CustomerDisplayMediaItemScheme),
  defaultDurationSeconds: z.number().optional(),
  shuffle: z.boolean().optional(),
});

export const CustomerDisplaySettingsScheme = z.object({
  active: z.boolean(),
  scaling: z.number(),
  imageResizeMode: z.enum(CustomerDisplayImageResizeModeType).optional(),
  idlePlaylist: CustomerDisplayIdlePlaylistScheme.nullable(),
  cartLayout: z.enum(CustomerDisplayCartLayoutType),
  cartMedia: CustomerDisplayMediaItemScheme.nullable(),
  backgroundColor: z.string().optional(),
});

export type CustomerDisplayMediaImage = z.infer<
  typeof CustomerDisplayMediaImageScheme
>;
export type CustomerDisplayMediaVideo = z.infer<
  typeof CustomerDisplayMediaVideoScheme
>;
export type CustomerDisplayMediaItem = z.infer<
  typeof CustomerDisplayMediaItemScheme
>;
export type CustomerDisplayIdlePlaylist = z.infer<
  typeof CustomerDisplayIdlePlaylistScheme
>;
export type CustomerDisplaySettings = z.infer<
  typeof CustomerDisplaySettingsScheme
>;

export type CustomerDisplaySettingsSource = {
  customerDisplayActive?: boolean | null;
  customerDisplayImage?: string | null;
  customerDisplayScaling?: number | null;
  customerDisplaySettings?: CustomerDisplaySettings | null;
};
